// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__161VG","questions":"styles_questions__39Z9M","footer":"styles_footer__12XR1"};